import type { TripCard, TripEvent } from '../../../redux/trip/trip.types';

/**
 * Represents a drop that requires user confirmation before being committed —
 * either because the card is already on that day (duplicate) or the venue is
 * closed on that date (closed).
 */
export interface PendingDrop {
  type: 'duplicate' | 'closed';
  card: TripCard;
  event?: TripEvent;
  dateISO: string;
}

/**
 * Shared easing curve used for all sortable item transitions (reorder animation).
 * Passed to `useSortable({ transition: SORTABLE_TRANSITION })`.
 */
export const SORTABLE_TRANSITION = {
  duration: 350,
  easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
} as const;

/**
 * Drop animation config for `<DragOverlay>`. Shorter than the sortable transition
 * so the ghost snaps back quickly after release without feeling sluggish.
 */
export const DROP_ANIMATION = {
  duration: 220,
  easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
} as const;
